import { Stack, Typography } from "@mui/material";
import { t } from "i18next";
import DashboardTable from "../../../components/Dashboard/DashboardTable";
import Template from "../../../components/Dashboard/Template";

const headerData = [
  {
    id: 1,
    label: "service",
  },
  {
    id: 2,
    label: "appointment",
  },
  {
    id: 3,
    label: "earning",
  },
];

const diplayRows = ["company_sub_services", "appointment", "totalEarnings"];

const TopSale = ({ allServices, isLoading }) => {
  return (
    <Template
      primaryHeading={t("topBookedServices")}
      secondaryHeading={t("hitList")}
    >
      {allServices?.length == 0 && isLoading?.states === false ? (
        <Stack height={"100%"} alignItems={"center"} justifyContent={"center"}>
          <Typography
            variant="h5"
            fontWeight={600}
            textTransform={"capitalize"}
          >
            {t("noDataFound")}!
          </Typography>
        </Stack>
      ) : (
        <DashboardTable
          showHeader={true}
          headerData={headerData}
          tableData={allServices || []}
          diplayRows={diplayRows}
        />
      )}
    </Template>
  );
};

export default TopSale;
